export default "__VITE_ASSET__CP771bTM__"